import pinia from "../core/pinia";
import { useEditorStore } from "../stores";

type TColumnName = string;
type TRowValue = string;

function validateEqual(v1: Record<string, string>, v2: Record<string, string>) {
  const keysV1 = Object.keys(v1).sort();
  const keysV2 = Object.keys(v2).sort();

  const valuesV1 = Object.values(v1).sort();
  const valuesV2 = Object.values(v2).sort();

  return (
    keysV1 === keysV2 &&
    valuesV1 === valuesV2
  );
}

function prepareDataset(dataset: {
  columns: string[];
  rows: {
    key: string;
    row: Record<string, any>;
  }[];
}[]) {
  return dataset.map((sheet) => {
    sheet.rows = sheet.rows.map(({ row }) => {
      return row;
    }) as any;
    return sheet;
  });
}

export function getUpdatedDatasetRow(surfaceIndex: number, rowIndex: number, rowData: Record<TColumnName, TRowValue>) {
  const editorStore = useEditorStore(pinia);
  const data = editorStore.getDataset;
  if (!data || !rowData) {
    throw new Error('[updateLoadedDatasetRow] Dataset is null');
  }
  const isEqual = validateEqual(data[surfaceIndex].rows[rowIndex].row, rowData);
  if (isEqual) {
    console.warn('[updateLoadedDatasetRow] Dataset row is equivalent, nothing happened');
    return;
  }
  data[surfaceIndex].rows[rowIndex].row = rowData;
  const preparedData = prepareDataset(data);
  return preparedData;
}